<template>
  <!-- prettier-ignore -->
  <b-container class="mt-4">
    <b-row>
      <b-col lg="8" class="mb-5">
        <h1 class="mt-5">404 Not Found</h1>
        <p>The requested URL {{ $route.path }} was not found on this server.</p>
        <h2 class="mt-4">Getting Help</h2>
        <p>Check out our <a href="https://help.soundslides.com">Soundslides help site</a>.</p>
        <h3 class="mt-4">Forum</h3>
        <p>Ask a question on our <a href="https://forum.soundslides.org/">Soundslides forum</a>, or search all forum posts. The forum is actively monitored by Tungite Lab's staff.</p>

        <h3>Email</h3>
        <p>Send an email to help@tungite.com and we'll get back to you within 1 business day.</p>
      </b-col>
      <Footer />
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer";
export default {
  name: "Help",

  components: {
    Footer
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 0.4em;
}
h2 {
  margin-bottom: 0.4em;
}
h3 {
  margin-bottom: 0.6em;
}
</style>
